<script lang="ts">
import { useThrottleFn } from '@vueuse/core'
import { defineComponent, ref } from 'vue'

import { getAssetURL } from '@/utils'
import { useStoreFX } from '@/webgl/composables/useStoreFX'

const urls = [
  'textures/fx/fx_bubble.png',
  'textures/fx/fx_leaf.png'
]

export default defineComponent({
  name: 'FXSelector',
  components: {
    //
  },
  props: {
    //
  },
  setup (props, { expose }) {
    const currentFX = ref(0)
    const isClicked = ref(false)
    const { updateFXIndex } = useStoreFX()

    const switchFX = (i: number) => {
      currentFX.value = i
      updateFXIndex(i)
      isClicked.value = !isClicked.value

      setTimeout(() => {
        isClicked.value = false
      }, 300)
    }

    const throttleSwitch = useThrottleFn(switchFX, 500)

    expose({
      currentFX
    })

    return {
      getAssetURL,
      isClicked,
      currentFX,
      throttleSwitch,
      urls
    }
  }
})
</script>

<template>
  <div class="fx-wrapper flex flex-row gap-6 items-center">
    <button
      v-for="(url, index) in urls"
      :key="url"
      class="fx-item p-1 border-2 border-transparent rounded-full aspect-square select-none"
      :class="{'border-white focused': currentFX === index+1}"
      :disabled="currentFX === index+1"
      @click="throttleSwitch(index+1)"
    >
      <div
        class="fx-inner p-1 rounded-full transform"
        :class="{'opacity-75': currentFX !== index+1, 'scaled-down': isClicked && currentFX === index+1}"
      >
        <img :src="getAssetURL(url)" :alt="url" class="h-10 min-w-10 aspect-square" />
      </div>
    </button>
  </div>
</template>

<style lang="scss" scoped>

.focused>div {
  background-color: rgba($c-white, 0.5);
}

.fx-inner {
  aspect-ratio: 1 / 1;
  backdrop-filter: $backdrop;
  background-color: $c-light;
  transition: all 0.3s ease-out;
  will-change: transform;
}

.scaled-down {
  transform: scale(0.6);
}

</style>
